const dataSelector = (attribute, value) =>
  value ? `[data-${attribute}="${value}"]` : `[data-${attribute}]`;

const formSelector = (formId) => dataSelector("driftrock-form", formId);

const stepsConfSelector = (formId) =>
  `${formSelector(formId)} ${dataSelector("steps-ids")}`;

const stepSelector = (formId, stepId) =>
  `${formSelector(formId)} ${dataSelector("step-id", stepId)}`;

const btnNextSelector = (formId) =>
  `${formSelector(formId)} ${dataSelector("step-next")}`;

const btnPrevSelector = (formId) =>
  `${formSelector(formId)} ${dataSelector("step-previous")}`;

const btmSubmitSelector = (formId) =>
  `${formSelector(formId)} ${dataSelector("form-submit")}`;

const activeInputsSelector = (formId, stepId) =>
  `${stepSelector(formId, stepId)} input, ${stepSelector(formId, stepId)} select, ${stepSelector(formId, stepId)} textarea`;

const recaptchaSelector = (formId) =>
  `${formSelector(formId)} ${dataSelector("recaptcha-container")}`;

const ui = {
  forms: () => document.querySelectorAll(formSelector()),
  stepsConf: (formId) => document.querySelector(stepsConfSelector(formId)),
  stepContainer: (formId, stepId) =>
    document.querySelector(stepSelector(formId, stepId)),
  btnNext: (formId) => document.querySelector(btnNextSelector(formId)),
  btnPrev: (formId) => document.querySelector(btnPrevSelector(formId)),
  btnSubmit: (formId) => document.querySelector(btmSubmitSelector(formId)),
  activeInputs: (formId, stepId) =>
    document.querySelectorAll(activeInputsSelector(formId, stepId)),
  recaptcha: (formId) => document.querySelector(recaptchaSelector(formId)),
};

export { ui };
